<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>settings</md-icon>
      </div>
      <h4 class="title">
        Adventure Assets
      </h4>
    </md-card-header>
    <md-card-content>
      <ul class="md-list nav-tabs md-theme-default">
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.extra')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Extra Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Extras
              <i class="md-icon md-icon-font md-theme-default"
                >person_add_alt_1</i
              >
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.guide')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Guide Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Guides
              <i class="md-icon md-icon-font md-theme-default">explore</i>
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.supplier')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Partner Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Partners
              <i class="md-icon md-icon-font md-theme-default"
                >settings_accessibility</i
              >
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.restaurant')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Restaurant Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Restaurants
              <i class="md-icon md-icon-font md-theme-default">local_dining</i>
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.accommodation')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Accommodation Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Accommodation
              <i class="md-icon md-icon-font md-theme-default">hotel</i>
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.vendor')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Vendor Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Vendors
              <i class="md-icon md-icon-font md-theme-default">shopping_cart</i>
            </div>
          </button>
        </li>
        <li
          class="md-list-item active md-primary"
          v-if="this.$allowed('crm.route.tour.staff')"
        >
          <button
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
            @click="$router.push({ name: 'Staff Management' })"
          >
            <div class="md-list-item-content md-ripple">
              Staff
              <i class="md-icon md-icon-font md-theme-default"
                >manage_accounts</i
              >
            </div>
          </button>
        </li>
      </ul>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>
